import { render, staticRenderFns } from "./InfoAdmin.vue?vue&type=template&id=ae57b430&scoped=true"
import script from "./InfoAdmin.vue?vue&type=script&lang=js"
export * from "./InfoAdmin.vue?vue&type=script&lang=js"
import style0 from "./InfoAdmin.vue?vue&type=style&index=0&id=ae57b430&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae57b430",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae57b430')) {
      api.createRecord('ae57b430', component.options)
    } else {
      api.reload('ae57b430', component.options)
    }
    module.hot.accept("./InfoAdmin.vue?vue&type=template&id=ae57b430&scoped=true", function () {
      api.rerender('ae57b430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/components/InfoAdmin.vue"
export default component.exports